import classnames from 'classnames'
import { useTranslation } from 'react-i18next'
import ButtonLink from '../../common/buttons/ButtonLink'

import classes from './ReportsTab.module.scss'
import { ReactComponent as FlameIcon } from '../../../assets/images/common/icons/flame-icon.svg'
import ReportsPlaceholder from '../../../assets/images/mock/reports-placeholder.webp'

const ReportsTab = () => {
  const { t } = useTranslation()

  return (
    <article className={classnames('p-5 d-flex', classes.reportsTab)}>
      <div className={classnames('d-flex flex-column', classes.leftPanel)}>
        <h2 className={classnames('mb-4 d-flex align-items-center', classes.title)}>
          <FlameIcon />
          <span className='ml-3'>{t('programs.manage.reports.comingSoon')}</span>
        </h2>
        <h3 className={classnames('mb-4', classes.subtitle)}>{t('programs.manage.reports.title')}</h3>
        <p className={classnames('mb-3', classes.firstText)}>{t('programs.manage.reports.firstText')}</p>
        <p className={classes.secondText}>{t('programs.manage.reports.secondText')}</p>
        <ButtonLink
          navigateTo='https://form.asana.com/?k=5r5aZmuhGUauVpPq43U6qA&d=280429732382352'
          target='_blank'
          isExternal
        >
          {t('programs.manage.reports.shareYourIdeas')}
        </ButtonLink>
      </div>
      <div className={classnames('ml-3 d-flex justify-content-center', classes.rightPanel)}>
        <img
          src={ReportsPlaceholder}
          alt={t('programs.manage.reports.imageAlt')}
          className={classes.image}
        />
      </div>
    </article>
  )
}

export default ReportsTab
